<template>
    <div class="storevisitdata">
        <div class="card">
            <van-field v-model="from.time" label="填表日期" readonly />
            <van-field v-model="from.userName" type="text" label="提报人姓名" placeholder="请输入姓名" />
            <van-field v-model="from.phone" type="tel" label="手机号" placeholder="请输入手机号" @blur="blurPhone" />
            <!-- <van-field readonly clickable name="picker" :value="from.dept" label="部门" placeholder="请选择部门"
                @click="pupupCascader = true" right-icon="arrow" rows="1" type="textarea" autosize /> -->
        </div>
        <div class="card">
            <van-field v-model="from.location" label="门店定位" rows="1" type="textarea" autosize readonly
                right-icon="location" placeholder="定位地址" @click-right-icon="getLoaLog" />
            <van-field readonly clickable name="picker" :value="from.distributor" label="经销商" placeholder="请选择经销商"
                @click="popupdistributor = true" right-icon="arrow" />
            <van-field v-model="distributorInput" placeholder="请输入经销商" v-if="inputdistributor" class="inputTailg"
                left-icon="edit" />
            <van-field readonly clickable name="picker" :value="from.storeName" label="门店名称" placeholder="请选择门店名称"
                @click="storeNameClickss" right-icon="arrow" :disabled="disabledDepartment" />
            <van-field v-model="departmentInput" placeholder="请输入门店名称" v-if="inputStore" class="inputTailg"
                left-icon="edit" />
        </div>
        <div class="card">
            <van-field name="radio" label="经营属性">
                <template #input>
                    <van-radio-group v-model="from.storeType" direction="horizontal">
                        <van-radio name="1">一网
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                        <van-radio name="2">二网
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <!-- <van-field readonly clickable name="picker" :value="from.startTime1" label="开始时间" placeholder="请选择走访开始时间"
                @click="openStart" right-icon="arrow" />
            <van-field readonly clickable name="picker" :value="from.endTime1" label="结束时间" placeholder="请选择走访结束时间"
                @click="openEnd" right-icon="arrow" /> -->
            <div class="uploadImg_box">
                <p class="left_title">门店照片（白天）</p>
                <div class="uploadImg">
                    <div class="imgbox" v-for="(item, index) in imgList" :key="index">
                        <img :src="item" class="carme" alt="" srcset="" @click="ImagePreviewcc(item)" />
                        <van-icon name="clear" class="closeImg" @click="deleteImg(index)" />
                    </div>

                    <div class="imgbox">
                        <van-uploader :after-read="afterRead" capture='camera'>
                        </van-uploader>
                        <!-- <img src="../../assets/upload@2x.png" class="carme" @click="goCamera" /> -->
                    </div>

                </div>
            </div>
            <div>
                <p class="tips_red">照片要求<br />
                    1、门面照，户外拍摄，包含门头、街景及左右店铺；<br />
                    2、室内照：进门向里拍摄、前后左右全景拍摄。</p>
            </div>

        </div>
        <!-- <img :src="baselll" alt="" style="width:100%" srcset=""> -->

        <div>
            <van-button type="primary" class="btn"  @click="onNext">保存</van-button>
        </div>


        <!-- 级联选择  部门-->
        <van-popup v-model="pupupCascader" round position="bottom">
            <van-cascader v-model="from.department" title="请选择部门级别" :options="options" @close="pupupCascader = false"
                @finish="onFinish" :field-names="fieldNames" />
        </van-popup>
        <!-- 时间选择 -->
        <van-popup v-model="popupTime" round position="bottom">
            <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
                @confirm="confirmTime" @cancel="cancelTime" />
        </van-popup>
        <!-- 经销尚轩选择 -->
        <van-popup v-model="popupdistributor" position="bottom" :style="{ height: '80%' }">
            <div>
                <!-- <van-picker title="请选择经销商" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" /> -->
                <div class="title_pupop">
                    <div class="cancel" @click="popupdistributor = false">取消</div>
                    <div class="title">请选择经销商</div>
                    <div class="confirm" @click="popupdistributor = false">确定</div>
                </div>
                <div>
                    <div>
                        <van-search v-model="searchvalue" show-action placeholder="请输入搜索关键词"
                            @clear="onSearchdistributor" @search="onSearchdistributor" @cancel="onSearchCancel" />
                    </div>
                    <div class="scllore">
                        <van-cell v-for="(item, index) of columns" :key="index" :title="item.dealerName"
                            @click="dealerNameClick(item)" />
                            <van-cell title="其他"   @click="dealerNameClick({ dealerId: '', dealerName: '其他' })" />
                    </div>
                </div>

            </div>
        </van-popup>
        <!-- 门店选择 -->
        <van-popup v-model="pupupMent" position="bottom" :style="{ height: '80%' }">
            <div>

                <div class="title_pupop">
                    <div class="cancel" @click="pupupMent = false">取消</div>
                    <div class="title">请选择门店名称</div>
                    <div class="confirm" @click="pupupMent = false">确定</div>
                </div>
                <div>
                    <div>
                        <van-search v-model="searchvalueStore" show-action placeholder="请输入搜索关键词" @search="onSearch"
                            @clear="onSearch" @cancel="onSearchCancel" />
                    </div>
                    <div class="scllore">
                        <van-cell v-for="(item, index) of storeList" :key="index" :title="item.storeName"
                            @click="storeNameClick(item)" />
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Toast, ImagePreview } from 'vant';
import { initMap, getAddress,convertToLoaction } from "../../utils/amap.js";
import { postUplodBase64, getDepts, getDistributor, getStoreNames, getCheckInspect, addInspect } from '../../apis/storeVisit.js'
import { addWatermark } from '../../utils/watermark.js'
import wxLocation from '@/utils/wxLocation'
import wxChooseImage from '@/utils/wxChooseImage'



export default {
    data() {
        return {
            from: {
                time: '',
                department: '',//门店
                distributor: '',//经销商

                "openId": "",
                "userName": "",
                "phone": "",
                "dept": "",
                "location": "",
                "city": "",
                "dealerId": "",
                "dealerName": "",
                "storeId": "",
                "storeName": "",
                "storeCode": "",
                "type": "1",
                storeType:'1',
                "startTime": "",
                "endTime": "",
                "picUrl": ""
            },
            fieldNames: {
                text: 'deptName',
                value: 'id',
                children: 'children',
            },
            distributorInput: '',//输入框
            departmentInput: '',
            dealerName: '',
            showPicker: false,
            searchvalueStore: '',
            pupupMent: false,
            popupTime: false,
            pupupCascader: false,
            popupdistributor: false,
            inputdistributor: false,//是否显示输入经销上
            inputStore: false,//是否显示输入门店
            disabledDepartment: false,
            minDate: new Date(2023, 0, 15),
            maxDate: new Date(2023, 0, 31),
            currentDate: new Date,
            options: [],//部门列表数据
            columns: [],//经销商列表数据
            storeList: [],//门店列表数据
            imgList: [],
            baselll: '',
            activeIcon: require('../../assets/owner/checked.png'),
            inactiveIcon: require('../../assets/owner/unchecked.png'),
            isEndOrStart: false,
            searchvalue: '',
            longitude: '',
            latitude: '',
            isNextSubmit: true
        }
    },
    created() {
        initMap()
        this.from.time = this.timeChange(new Date());
        getDepts().then(res => {
            this.options = res.data;
        })
        this.from.openId = localStorage.getItem('openid') || '';
    },
    async mounted() {
        console.log(window.location.href)
        let res = await wxLocation.getLocation('tailg')
        console.log(res)
        if (res.latitude) {
            this.latitude = res.latitude
            this.longitude = res.longitude;
            this.getAddress();
        } else {
            // window.location.reload();
            Toast({
                message: '获取位置失败，请重试'
            })
        }
        // let res = await this.getLoaction()// wxLocation.getLocation('tailg')
        // console.log(res)
        // if (res.length>0) {
        //     this.latitude = res[1]
        //     this.longitude = res[0];
        //     this.getAddress();
        // } else {
        //     // window.location.reload();
        //     Toast({
        //         message: '获取位置失败，请重试'
        //     })
        // }
    },
    methods: {
        storeNameClickss() {
            if (this.from.dealerName) {
                this.pupupMent = true
            } else {
                Toast({
                    message: '请先选择经销商'
                })
            }

        },
        ImagePreviewcc(val) {
            ImagePreview([val]);
        },
        async getLoaLog() {
            let res = await wxLocation.getLocation()
            if (res.latitude) {
                this.latitude = res.latitude
                this.longitude = res.longitude;
                this.getAddress();
            } else {
                Toast({
                    message: '获取位置失败，请重试'
                })
            }
        },
        onSearchdistributor() {
            this.getDistributor();
        },
        //选择经销商
        dealerNameClick(val) {
            this.from.dealerId = val.dealerId;
            this.from.dealerName = val.dealerName;
            this.from.distributor = val.dealerName;
            this.popupdistributor = false;
            if (val.dealerName == '其他') {
                this.inputdistributor = true;
                this.inputStore = true;
                this.disabledDepartment = true;
            } else {
                this.inputdistributor = false;
                this.inputStore = false;
                this.disabledDepartment = false;
                this.getStoreNames();
            }
        },
        //查询门店
        getStoreNames() {
            let parems = {
                dealerId: this.from.dealerId,
                storeName: this.searchvalueStore
            }
            getStoreNames(parems).then(res => {
                this.storeList = res.data;
                this.storeList.push({ storeId: '', storeName: "其他", storeCode: "" })
            })
        },
        //选择门店
        storeNameClick(item) {
            this.pupupMent = false;
            this.from.storeName = item.storeName;
            this.from.storeId = item.storeId;
            this.from.storeCode = item.storeCode;
            if (item.storeName == '其他') {
                this.inputStore = true;
                this.isNextSubmit = true;
            } else {
                this.inputStore = false;
                let parems = {
                    openId: this.$store.state.openId,
                    storeName: this.from.storeName,
                    dealerName: this.from.dealerName
                }
                // getCheckInspect(parems).then(res => {
                //     if (res.data == true) {
                //         Toast({
                //             message: '门店已督查，请勿重复提交'
                //         })
                //         this.isNextSubmit = false;
                //     } else {
                //         this.isNextSubmit = true;
                //     }
                // })
            }
        },

        afterRead(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file);
            if (this.imgList.length >= 6) {
                Toast({
                    message: '图片最多上传6张'
                })
                return
            }
            let address = `地址：${this.from.location}`;
            let lat = `经度：${this.longitude}纬度:${this.latitude}`;
            let time = new Date().toLocaleString()

            addWatermark({
                url: file.content,
                address,
                lat,
                time,
                callback: (val) => {
                    this.baselll = val;
                    let data = {
                        base: val
                    }
                    postUplodBase64(data).then(res => {
                        if (res.data) {
                            this.imgList.push(res.data.objectUrl)
                            console.log('this.imgList', this.imgList)
                        }
                    })
                }
            })
        },
        /**
         * 拍照上传，加水印
         */
        goCamera() {
            if (this.imgList.length >= 6) {
                Toast({
                    message: '图片最多上传6张'
                })
                return
            }
            wxChooseImage.getLocalImgData().then(res => {
                this.baselll = 'data:image/jpeg;base64,' + res;

                let address = `地址：${this.from.location}`;
                let lat = `经度：${this.longitude}纬度:${this.latitude}`;
                let time = new Date().toLocaleString()

                addWatermark({
                    url: this.baselll,
                    address,
                    lat,
                    time,
                    callback: (val) => {
                        console.log('测试==返回')
                        let data = {
                            base: val
                        }
                        postUplodBase64(data).then(res => {
                            if (res.data) {
                                this.imgList.push(res.data.objectUrl)
                            }
                        })
                    }
                })
            })


        },
        onNext() {

            if (this.inputdistributor) {
                this.from.dealerName = this.distributorInput;
            }
            if (this.inputStore) {
                this.from.storeName = this.departmentInput;

            }
            this.from.picUrl = this.imgList.join(',');
            console.log(this.from)
            if (!this.from.userName) {
                Toast({ message: '请填写表单内容' })
                return
            }
            if (!this.from.phone) {
                Toast({ message: '请填写表单内容' })
                return
            }
            // if(!this.from.dept){
            //     Toast({message:'请填写表单内容'})
            //     return
            // }
            if (!this.from.dealerName) {
                Toast({ message: '请填写表单内容' })
                return
            }
            if (!this.from.storeName) {
                Toast({ message: '请填写表单内容' })
                return
            }
            // if(!this.from.startTime){
            //     Toast({message:'请填写表单内容'})
            //     return
            // }
            // if(!this.from.endTime){
            //     Toast({message:'请填写表单内容'})
            //     return
            // }
            if (!this.from.picUrl) {
                Toast({ message: '请填写表单内容' })
                return
            }

            this.$store.state.storeVisit.inspect = this.from;
            let data = {
                inspect:this.from
            }
            addInspect(data).then(res => {
                if (res.status === 0) {
                    this.keepRemoveCache();
                    this.$router.replace('/storevisit')
                } else {
                    Toast({
                        message: res.msg
                    })
                }
            })
            // this.$router.push({
            //     path: '/questionnaire'
            // })
        },
        openStart() {
            this.isEndOrStart = true;
            this.popupTime = true
        },
        openEnd() {
            this.isEndOrStart = false;
            this.popupTime = true
        },
        confirmTime(v) {
            this.popupTime = false;
            Math.round(new Date(v))
            if (this.isEndOrStart) {
                this.from.startTime = Math.round(new Date(v))
                this.from.startTime1 = this.timeChange(v)
            } else {
                this.from.endTime = Math.round(new Date(v))
                this.from.endTime1 = this.timeChange(v)
            }
        },
        cancelTime() {
            this.popupTime = false;
        },
        onConfirm(value, index) {
            // Toast(`当前值：${value}, 当前索引：${index}`);
            this.popupdistributor = false;
            this.from.distributor = value;
            if (value == '其他') {
                this.inputdistributor = true;
                this.inputStore = true;
                this.disabledDepartment = true;
            } else {
                this.inputdistributor = false;
                this.inputStore = false;
            }
        },
        onFinish({ selectedOptions }) {
            console.log(this.from.department, selectedOptions)
            this.from.deptId = this.from.department;
            this.from.dept = selectedOptions.map((option) => option.deptName).join('/');
        },
        /**
         * 删除上传图片
         */
        deleteImg(i) {
            this.imgList.splice(i, 1)
        },
        blurPhone() {
            if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.from.phone))) {
                Toast({
                    message: '请输入正确的手机号'
                });
                this.from.phone = ''
                return false;
            }
        },
        async getAddress() {
            let str = await getAddress([this.longitude, this.latitude])
            // let str = await getAddress([120.438427, 31.547105])
            console.log(str)
            this.from.location = str;
            // str.addressComponent.province
            // str.addressComponent.city
            if (this.from.location) {
                this.getDistributor()
            }
        },
        getDistributor() {
            let parames = {
                dealerName: this.searchvalue,
                address: this.from.location
            }
            getDistributor(parames).then(res => {
                if (res.status == 4002) {
                    Toast({
                        message: '地址解析失败，请重新定位后再试'
                    })
                } else {
                    this.columns = res.data;
                    
                }
                // this.columns.push({ dealerId: '', dealerName: "其他" })

            })
        },

        /**
         * 搜索-- 门店搜搜
         */
        onSearch() {
            this.getStoreNames();
        },
        /**
         * 搜索取消
         */
        onSearchCancel() { },
        /**
         * 时间转换
         */
        timeChange(val) {
            return `${val.getFullYear()}年${val.getMonth() + 1}月${val.getDate()}日`
        },
        async getloalogAddress(){
            let res = await this.getLoaction();
            if (res.length>0) {
                this.latitude = res[1]
                this.longitude = res[0];
                this.getAddress();
            } else{
                let res = await  wxLocation.getLocation('tailg')
                if (res.latitude) {
                    this.latitude = res.latitude
                    this.longitude = res.longitude;
                    this.getAddress();
                }else{
                    window.location.reload();
                }
            }

        },
        //测试用，无法在生产环境中使用
        getLoaction() {
            let PositionOptions = {
                enableHighAccuracy: true
            }
            return new Promise((resolve, reject) => {
                if ('geolocation' in navigator) {
                    navigator.geolocation.getCurrentPosition((res) => {
                        // resolve([res.coords.longitude, res.coords.latitude])
                      convertToLoaction([res.coords.longitude, res.coords.latitude]).then(res =>{
                        console.log('h5定位转换',res)
                        resolve(res)
                      })
                    }, (error) => {
                        resolve([])
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                               console.log("用户拒绝获取位置信息") ;
                               Toast({
                                    message: '获取位置失败，请重试'
                                })
                                break;
                            case error.POSITION_UNAVAILABLE:
                            console.log("位置信息不可用 ")
                            Toast({
                                    message: '获取位置失败，请重试'
                                })
                                break;
                            case error.TIMEOUT:
                            console.log("请求超时")
                                break;
                            default:
                            console.log("未知错误信息")
                                break;
                        }
                    }, PositionOptions)
                } else {
                    console.log('不支持获取定位')
                    Toast({
                        message: '获取位置失败，请重试'
                    })
                    resolve([])
                }
            })

        },

        //请输keep缓存
        keepRemoveCache() {
            let vnode = this.$vnode
            let parentVnode = vnode && vnode.parent;
            if (parentVnode && parentVnode.componentInstance && parentVnode.componentInstance.cache) {
                var key = vnode.key == null
                    ? vnode.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '')
                    : vnode.key;
                var cache = parentVnode.componentInstance.cache;
                var keys = parentVnode.componentInstance.keys;
                console.log(cache, keys)
                keys.forEach(element => {
                    cache[element] = null
                });
                if (cache[key]) {
                    // remove key
                    if (keys.length) {
                        var index = keys.indexOf(key)
                        if (index > -1) {
                            keys.splice(index, 1)
                        }
                    }

                    cache[key] = null
                }
            }
        }

    },
}
</script>

<style lang="scss" >
.storevisitdata {
    background-color: #F7F7F7;
    padding: 15px;

    .van-uploader__upload {
        width: 100px !important;
        height: 100px !important;
    }

    .scllore {
        height: calc(80vh - 120px);
        overflow-y: scroll;
    }

    .title_pupop {
        display: flex;
        justify-content: space-between;
        padding: 20px 15px;
        border-bottom: 1px solid #f0f0f0;

        .cancel {
            font-size: 18px;
            font-weight: 400;
            color: #999999;
        }

        .title {
            font-size: 18px;
            font-weight: 500;
            color: #272637;
        }

        .confirm {
            font-size: 18px;
            font-weight: 400;
            color: #FF232D;
        }
    }

    .img-icon {
        height: 20px;
    }

    .tips_red {
        font-size: 12px;
        font-weight: 500;
        color: #FF232D;
        line-height: 16px;
        text-align: left;
        margin-left: 8px;
    }

    .uploadImg_box {
        margin-left: 8px;
    }

    .btn {
        width: 80%;
        background: linear-gradient(175deg, #FF232D, #FF5C63);
        border-radius: 49px;
        border: 0;
    }

    .card {
        background-color: #fff;
        border-radius: 8px;
        padding: 8px;
        margin-bottom: 15px;

        .inputTailg {
            background: #F7F7F7;
            border-radius: 4px;
            width: 70%;
            right: -30%;
        }

        .left_title {
            text-align: left;
            font-size: 14px;
            font-weight: 500;
            color: #333333;
        }
    }

    .uploadImg {
        display: flex;
        flex-wrap: wrap;

        .imgbox {
            position: relative;
            margin-right: 10px;
            width: 30%;
        }

        .carme {
            width: 100%;
            height: 100px;
        }

        .closeImg {
            position: absolute;
            font-size: 22px;
            color: #777;
            font-weight: bold;
            right: -5px;
            top: 0;
            z-index: 999;
        }
    }
}
</style>